<article class="noticia-card">
  <div class="noticia-card-imagem-wrap">
    <img class="noticia-card-imagem" [ngSrc]="noticia().imagem" fill alt="" />

    @if (noticia().categoria; as categoria) {
      <span class="noticia-card-badge" [style.background]="categoria.cor">
        {{ categoria.rotulo }}
      </span>
    }
  </div>

  <div class="noticia-card-conteudo">
    <p class="noticia-card-data">
      <i-lucide name="calendar" size="14" aria-hidden="true"></i-lucide>
      {{ noticia().data | dataNoticia }}
    </p>

    <h3 class="noticia-card-titulo">{{ noticia().titulo }}</h3>
    <p class="noticia-card-descricao">{{ noticia().descricao }}</p>

    <a class="noticia-card-link" [routerLink]="rota()">
      Ler mais
      <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
    </a>
  </div>
</article>
